// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryHeading_wrapper__RXCiY","inner":"CategoryHeading_inner__WzViX","markdown":"CategoryHeading_markdown__nnzCa"};